
import { ISelectItem } from "winfakt-vue-components/src/classes";
import Vue from "vue";
export default Vue.extend({
	props: {
		value: {
			type: Number,
			required: true
		},
		fancy: Boolean,
		label: String
	},
	computed: {
		items():ISelectItem<number>[]{
			return [{
					text: "Niet prio",
					value: 1
				},
				{
					text: "Prio",
					value: 2
				},
				{
					text: "Dringend",
					value: 3
				},
				{
					text: "Meest dringend",
					value: 4
				}
			];
		}
	},
	methods: {
		onInput(value:number){
			this.$emit("input", value);
		}
	}
});
